import React from 'react';
import "../styles/global.css";
import { Link } from "react-router-dom";
import KarolPlankPortrait from '../images/Obrázok WhatsApp 2025-06-03 o 21.20.05_4a9032c3 (1).jpg'; // <-- TOTO JE NOVÝ RIADOK
// Uisti sa, že cesta ../assets/Gemini_Generated_Image_ojxyarojxyarojxy.jpg je správna
// z pohľadu umiestnenia About.js (About.js je v src/components, takže ../assets ťa dostane do src/assets)

export default function About() {
  return (
    <div className="about-container">
      <div className="about-content-wrapper">
        <div className="about-photo-container">
          {/* Použi importovanú premennú ako src */}
          <img src={KarolPlankPortrait} alt="JUDr. Karol Plank" className="about-photo" />
        </div>

        <div className="about-text-sections-wrapper">
          <div className="about-text-section">
            <h2 className="section-title">O advokátovi</h2>
            <p className="text">
              O spoločnosti:
              Obchodná spoločnosť JUDr. KAROL PLANK Advokátska kancelária, s.r.o. poskytuje celé spektrum právnych služieb pre fyzické a právnické osoby na Slovensku.
              V rámci poskytovaných právnych služieb sa advokátska kancelária JUDr. Karola Planka zameriava na poskytovanie komplexného právneho servisu pre klientov v oblasti trestného práva, rodinného práva, občianskoprávnych a obchodnoprávnych vzťahov a s tým súvisiacu sporovú agendu.
            </p>
          </div>

          <div className="about-text-section">
            <h3 className="section-subtitle">O spoločnosti</h3>
            <p className="text">
              Spoločníkom a konateľom spoločnosti je JUDr. Karol Plank, ktorý je zapísaný v zozname SAK pod ev. č. 7661.
              JUDr. Karol Plank absolvoval Právnickú fakultu Univerzity Komenského v Bratislave v roku 2012. Po absolvovaní vysokoškolského štúdia pôsobil od roku 2012 v advokácii, ako advokátsky koncipient.
              V roku 2015 úspešne absolvoval rigoróznu skúšku na Paneurópskej Vysokej Škole v Bratislave a získal titul JUDr.
              JUDr. Karol Plank absolvoval advokátsku skúšku s vyznamenaním v roku 2017 a od roku 2018 vykonáva samostatný výkon advokácie prostredníctvom obchodnej spoločnosti JUDr. KAROL PLANK Advokátska kancelária, s.r.o.
            </p>
          </div>
        </div>
      </div>
      <Link to="/specializacia" className="btn-secondary">Všetky služby</Link>
    </div>
  );
}